class ProductSwipeGallery {
    constructor() {
        this.galleries = new Map();
        this.init();
    }

    init() {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => this.setupGalleries());
        } else {
            this.setupGalleries();
        }

        // Re-inicjalizuj po resize
        let resizeTimeout;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => this.setupGalleries(), 250);
        });
    }

    setupGalleries() {
        // TYLKO na stronach kolekcji - nie na homepage
        if (!window.location.pathname.includes('/collections/')) {
            return;
        }
        
        // Tylko na mobile
        if (window.innerWidth > 768) {
            // Cleanup existing galleries na desktop
            this.cleanupAllGalleries();
            return;
        }
        
        // Setup galleries for mobile
        
        // Znajdź wszystkie produkty z wieloma obrazami
        const swipeDataElements = document.querySelectorAll('.mobile-swipe-data');
        
        swipeDataElements.forEach(dataElement => {
            const productId = dataElement.getAttribute('data-product-id');
            const productCard = dataElement.closest('.product-item') || dataElement.closest('.card-media');
            
            if (!productCard || this.galleries.has(productId)) return;
            
            try {
                const imagesData = JSON.parse(dataElement.textContent);
                this.setupProductSwipe(productCard, productId, imagesData.images);
            } catch (error) {
                // Błąd parsowania danych obrazów
            }
        });
    }

    cleanupAllGalleries() {
        this.galleries.clear();
    }

    setupProductSwipe(productCard, productId, images) {
        if (images.length <= 1) return;

        const gallery = {
            productCard,
            images,
            currentIndex: 0,
            mainImage: productCard.querySelector('img:last-of-type'),
            cardLink: productCard.querySelector('.card-link'),
            isActive: false,
            startX: 0,
            startY: 0,
            startTime: 0,
            hasMoved: false,
            isScrolling: false,
            isSwipeDetected: false,
            isDragging: false,
            currentTransform: 0,
            permanentContainer: null,
            imageTrack: null
        };

        if (!gallery.mainImage) return;

        // Nowe podejście: utwórz stały kontener zamiast modyfikować oryginalny obraz
        this.createPermanentContainer(gallery);

        // Dodaj wskaźniki
        this.addIndicators(gallery);
        
        // Dodaj touch events
        this.addTouchEvents(gallery);

        this.galleries.set(productId, gallery);
    }

    createPermanentContainer(gallery) {
        // Sprawdź czy kontener już istnieje
        if (gallery.productCard.querySelector('.swipe-permanent-container')) return;

        const container = document.createElement('div');
        container.className = 'swipe-permanent-container';
        container.style.cssText = `
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 10;
            pointer-events: none;
        `;

        const imageTrack = document.createElement('div');
        imageTrack.className = 'image-track';
        imageTrack.style.cssText = `
            display: flex;
            width: ${gallery.images.length * 100}%;
            height: 100%;
            transition: transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
            will-change: transform;
        `;

        // Stwórz obrazy dla każdego zdjęcia w galerii
        gallery.images.forEach((imageData, index) => {
            const imageWrapper = document.createElement('div');
            imageWrapper.className = 'image-wrapper';
            imageWrapper.style.cssText = `
                width: ${100 / gallery.images.length}%;
                height: 100%;
                flex-shrink: 0;
                display: flex;
                align-items: center;
                justify-content: center;
            `;

            const img = document.createElement('img');
            const normalizedSrc = imageData.src.startsWith('//') ? 'https:' + imageData.src : imageData.src;
            
            img.src = normalizedSrc;
            img.alt = imageData.alt;
            img.srcset = normalizedSrc;
            img.style.cssText = `
                width: 100%;
                height: 100%;
                object-fit: cover;
                display: block;
            `;

            imageWrapper.appendChild(img);
            imageTrack.appendChild(imageWrapper);
        });

        container.appendChild(imageTrack);
        
        // Znajdź odpowiedni kontener nadrzędny i dodaj stały kontener
        const parentContainer = gallery.mainImage.closest('.card-media') || gallery.mainImage.parentElement;
        parentContainer.style.position = 'relative';
        parentContainer.appendChild(container);
        
        // Ukryj oryginalny obraz
        gallery.mainImage.style.opacity = '0';
        gallery.mainImage.style.pointerEvents = 'none';
        
        // Ustaw początkową pozycję (pierwszy obraz)
        const containerWidth = container.offsetWidth;
        const targetTransform = -(gallery.currentIndex * containerWidth);
        imageTrack.style.transform = `translate3d(${targetTransform}px, 0, 0)`;
        
        // Zapisz referencje
        gallery.permanentContainer = container;
        gallery.imageTrack = imageTrack;
        gallery.currentTransform = targetTransform;
    }

    addIndicators(gallery) {
        // Sprawdź czy już nie ma wskaźników
        if (gallery.productCard.querySelector('.swipe-indicators')) return;

        const indicators = document.createElement('div');
        indicators.className = 'swipe-indicators';
        indicators.style.cssText = `
            position: absolute;
            bottom: 10px;
            left: 50%;
            transform: translateX(-50%);
            display: flex;
            gap: 5px;
            z-index: 100;
            pointer-events: none;
        `;

        gallery.images.forEach((_, index) => {
            const dot = document.createElement('span');
            dot.className = `indicator-dot ${index === 0 ? 'active' : ''}`;
            dot.style.cssText = `
                width: 6px;
                height: 6px;
                background-color: ${index === 0 ? 'white' : 'rgba(255,255,255,0.5)'};
                border-radius: 50%;
                transition: background-color 0.2s ease;
            `;
            indicators.appendChild(dot);
        });

        gallery.productCard.style.position = 'relative';
        gallery.productCard.appendChild(indicators);
        gallery.indicators = indicators;
    }

    addTouchEvents(gallery) {
        const handleStart = (e) => {
            const clientX = e.touches ? e.touches[0].clientX : e.clientX;
            const clientY = e.touches ? e.touches[0].clientY : e.clientY;
            
            gallery.startX = clientX;
            gallery.startY = clientY;
            gallery.startTime = Date.now();
            gallery.hasMoved = false;
            gallery.isScrolling = false;
            gallery.isSwipeDetected = false;
            gallery.isDragging = false;
            gallery.isActive = e.type.includes('mouse') || e.type.includes('touch');
        };

        const handleMove = (e) => {
            if (!gallery.isActive || gallery.isScrolling) return;
            
            const clientX = e.touches ? e.touches[0].clientX : e.clientX;
            const clientY = e.touches ? e.touches[0].clientY : e.clientY;
            
            const deltaX = Math.abs(clientX - gallery.startX);
            const deltaY = Math.abs(clientY - gallery.startY);
            const rawDeltaX = clientX - gallery.startX;
            
            if (!gallery.hasMoved) {
                // Pierwszy ruch - określ kierunek
                if (deltaY > deltaX && deltaY > 10) {
                    gallery.isScrolling = true;
                    return;
                }
                if (deltaX > 10 && deltaX > deltaY) {
                    gallery.hasMoved = true;
                    gallery.isSwipeDetected = true;
                    gallery.isDragging = true;
                    
                    // Wyłącz transition podczas przeciągania
                    if (gallery.imageTrack) {
                        gallery.imageTrack.style.transition = 'none';
                    }
                    
                    // Teraz blokuj pointer events - tylko gdy wykryto horizontal swipe
                    if (gallery.cardLink) {
                        gallery.cardLink.style.pointerEvents = 'none';
                    }
                }
            }
            
            // Zapobiegaj scrollowaniu dla horizontal swipe
            if (gallery.isSwipeDetected && deltaX > deltaY) {
                e.preventDefault();
            }
            
            // Animuj w czasie rzeczywistym podczas przeciągania
            if (gallery.isDragging && gallery.imageTrack) {
                const containerWidth = gallery.permanentContainer.offsetWidth;
                const currentOffset = -(gallery.currentIndex * containerWidth);
                
                // Ogranicz ruch żeby nie wychodzić za granice
                let dragOffset = rawDeltaX;
                const maxDrag = containerWidth * 0.3; // Maksymalnie 30% szerokości
                
                // Jeśli jesteśmy na pierwszym obrazie i przeciągamy w prawo
                if (gallery.currentIndex === 0 && rawDeltaX > 0) {
                    dragOffset = Math.min(rawDeltaX * 0.3, maxDrag);
                }
                // Jeśli jesteśmy na ostatnim obrazie i przeciągamy w lewo
                else if (gallery.currentIndex === gallery.images.length - 1 && rawDeltaX < 0) {
                    dragOffset = Math.max(rawDeltaX * 0.3, -maxDrag);
                }
                
                const newTransform = currentOffset + dragOffset;
                gallery.currentTransform = newTransform;
                gallery.imageTrack.style.transform = `translate3d(${newTransform}px, 0, 0)`;
            }
        };

        const handleEnd = (e) => {
            const wasSwiping = gallery.isSwipeDetected;
            const wasDragging = gallery.isDragging;
            
            if (!gallery.isActive || gallery.isScrolling || !gallery.hasMoved) {
                gallery.isActive = false;
                gallery.isDragging = false;
                return;
            }
            
            const clientX = e.changedTouches ? e.changedTouches[0].clientX : e.clientX;
            const deltaX = clientX - gallery.startX;
            const deltaTime = Date.now() - gallery.startTime;
            
            // Przywróć transition po zakończeniu przeciągania
            if (gallery.imageTrack) {
                gallery.imageTrack.style.transition = 'transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
            }
            
            // Sprawdź czy to był prawidłowy swipe
            const isValidSwipe = Math.abs(deltaX) > 50 && deltaTime < 600 && wasSwiping;
            const shouldChange = isValidSwipe || (gallery.permanentContainer && Math.abs(deltaX) > gallery.permanentContainer.offsetWidth * 0.3);
            
            if (shouldChange) {
                // Zapobiegaj kliku card-link po swipe
                e.preventDefault();
                e.stopPropagation();
                
                if (deltaX > 0 && gallery.currentIndex > 0) {
                    this.previousImage(gallery);
                } else if (deltaX < 0 && gallery.currentIndex < gallery.images.length - 1) {
                    this.nextImage(gallery);
                } else {
                    // Wróć do pozycji wyjściowej jeśli próba wyjścia poza granice
                    this.snapToCurrentImage(gallery);
                }
            } else if (wasDragging) {
                // Wróć do pozycji wyjściowej jeśli swipe był za słaby
                this.snapToCurrentImage(gallery);
            }
            
            // Przywróć card-link tylko jeśli został zablokowany
            if (wasSwiping && gallery.cardLink) {
                setTimeout(() => {
                    gallery.cardLink.style.pointerEvents = 'auto';
                }, 50);
            }
            
            gallery.isActive = false;
            gallery.isSwipeDetected = false;
            gallery.isDragging = false;
        };


        
        // Touch events
        gallery.productCard.addEventListener('touchstart', handleStart, { passive: true });
        gallery.productCard.addEventListener('touchmove', handleMove, { passive: false });
        gallery.productCard.addEventListener('touchend', handleEnd, { passive: false });
        
        // Mouse events (dla testowania na desktop)
        gallery.productCard.addEventListener('mousedown', handleStart);
        gallery.productCard.addEventListener('mousemove', handleMove, { passive: false });
        gallery.productCard.addEventListener('mouseup', handleEnd);
        gallery.productCard.addEventListener('mouseleave', handleEnd);
    }

    snapToCurrentImage(gallery) {
        if (!gallery.imageTrack) return;
        
        // Włącz transition dla snap animacji
        gallery.imageTrack.style.transition = 'transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
        
        const containerWidth = gallery.permanentContainer.offsetWidth;
        const targetTransform = -(gallery.currentIndex * containerWidth);
        gallery.imageTrack.style.transform = `translate3d(${targetTransform}px, 0, 0)`;
        gallery.currentTransform = targetTransform;
    }

    nextImage(gallery) {
        gallery.lastSwipeDirection = 'left';
        gallery.currentIndex = (gallery.currentIndex + 1) % gallery.images.length;
        this.updateImage(gallery);
    }

    previousImage(gallery) {
        gallery.lastSwipeDirection = 'right';
        gallery.currentIndex = gallery.currentIndex === 0 
            ? gallery.images.length - 1 
            : gallery.currentIndex - 1;
        this.updateImage(gallery);
    }

    updateImage(gallery) {
        if (!gallery.imageTrack) return;
        
        // Włącz transition dla animacji zmiany obrazu
        gallery.imageTrack.style.transition = 'transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
        
        const containerWidth = gallery.permanentContainer.offsetWidth;
        const targetTransform = -(gallery.currentIndex * containerWidth);
        gallery.imageTrack.style.transform = `translate3d(${targetTransform}px, 0, 0)`;
        gallery.currentTransform = targetTransform;
        
        // Aktualizuj wskaźniki
        this.updateIndicators(gallery);
    }

    updateIndicators(gallery) {
        if (!gallery.indicators) return;
        
        const dots = gallery.indicators.querySelectorAll('.indicator-dot');
        dots.forEach((dot, index) => {
            const isActive = index === gallery.currentIndex;
            dot.style.backgroundColor = isActive ? 'white' : 'rgba(255,255,255,0.5)';
            dot.className = `indicator-dot ${isActive ? 'active' : ''}`;
        });
    }
}

// Inicjalizuj gdy DOM jest gotowy
new ProductSwipeGallery();